import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaTimes } from "react-icons/fa";

function StudentNavbar() {
  const [isNavVisible, setIsNavVisible] = useState(false);
  const [isExercisesOpen, setIsExercisesOpen] = useState(false);

  const toggleNav = () => {
    setIsNavVisible(!isNavVisible);
  };

  // No scroll-based navbar transitions needed here

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showMobileMenu = windowWidth <= 768;

  return (
    <>
      {isNavVisible ? (
        <ul className={`nav-items`}>
          <li className="nav-item" style={{color :"#fff"}}>{showMobileMenu ? <GiHamburgerMenu onClick={() => toggleNav()} /> : ""}</li>
        </ul>
      ) : (
        <ul className={`nav-items`}>
          <li className="nav-item" style={{color :"#fff"}}>{!showMobileMenu ? "" : <FaTimes onClick={() => toggleNav()} />}</li>
          <li className="nav-item">
            <Link to="/">Home</Link>
          </li>
          <li className="nav-item">
            <Link to="/dashboard/student">Dashboard</Link>
          </li>
          <li
            className="nav-item dropdown"
            onMouseEnter={() => setIsExercisesOpen(true)}
            onMouseLeave={() => setIsExercisesOpen(false)}
          >
            <button
              type="button"
              className="nav-link-button"
              onClick={() => setIsExercisesOpen((prev) => !prev)}
            >
              Exercises
            </button>
            <ul className={`dropdown-menu ${isExercisesOpen ? "show" : ""}`}>
              <li>
                <Link to="/write" onClick={() => setIsExercisesOpen(false)}>Text Exercise</Link>
              </li>
              <li>
                <Link to="/select-image-document" onClick={() => setIsExercisesOpen(false)}>Give Passage Based Test</Link>
              </li>
              <li>
                <Link to="/select-audio-exercise-level" onClick={() => setIsExercisesOpen(false)}>Give Audio Based Test</Link>
              </li>
            </ul>
          </li>
          <li className="nav-item">
            <Link to="/attendance/history">Attendance</Link>
          </li>
          <li className="nav-item">
            <Link to="/profile">Profile</Link>
          </li>
        </ul>
      )}
    </>
  );
}

export default StudentNavbar;
